jQuery(function(){
  $('*[data-show-on-check]').each(function(){
    SamFormHelper.requiredOnCheck($(this));
    SamFormHelper.showOnCheck($(this));
  });

  $('*[data-show-on-check]').on('click', function(){
    SamFormHelper.requiredOnCheck($(this));
    SamFormHelper.showOnCheck($(this));
  });

  $('*[data-hide-on-check]').on('click', function(event){
    SamFormHelper.notRequiredOnCheck($(this));
    SamFormHelper.hideOnCheck($(this));
  });

  $('.back-to-login').on('click', function(event){
    $('#confirm-close-modal').modal();
  });

  $('#confirm-close-modal.confirmed').click(function() {
    window.location = $('#confirm-close-modal.confirmed').href;
  });

});

export const SamFormHelper = (function($) {
  function showOnCheck(element) {
    if (element.data('show-on-check') === '') {
      return;
    }
    if(element.is(':checked')) {
      $('#' + element.data('show-on-check')).removeClass('sam-hidden');
    } else {
      $('#' + element.data('show-on-check')).addClass('sam-hidden');
    }
  }
  function hideOnCheck(element) {
    if (element.data('hide-on-check') === '') {
      return;
    }
    if(element.is(':checked')) {
      $('#' + element.data('hide-on-check')).addClass('sam-hidden');
    } else {
      $('#' + element.data('hide-on-check')).removeClass('sam-hidden');
    }
  }

  function requireRadioButtonSelection(tab, element) {
    $('#' + tab + ' .sam-required-error').remove();
    if ($(element + ':checked').length == 0) {
      $('#' + tab + ' .sam-form-header').append('<div class=\'sam-required-error\'>Please select an option to continue</div>');
      event.preventDefault();
      TabLinks.openTab(event, tab);
    }
  }

  function requiredOnCheck(element) {
    if (element.data('required-on-check') === '') {
      return;
    }
    if(element.is(':checked')) {
      makeRequiredByName(element.data('required-on-check'), element.data('form-type'));
    } else {
      removeRequiredByName(element.data('required-on-check'), element.data('form-type'));
    }
  }

  function notRequiredOnCheck(element) {
    if (element.data('not-required-on-check') === '') {
      return;
    }
    removeRequiredByName(element.data('not-required-on-check'), element.data('form-type'));
  }

  function makeRequiredByName(fieldName, sam){
    if (typeof sam === 'undefined') {
      sam = 'pb';
    }

    var name = '\'sam_' + sam + '_submission[' + fieldName + ']\'';

    $('[name=' + name + ']').attr('required', 'true');
    $('label[for=' + name + ']').addClass('required');
  }

  function removeRequiredByName(fieldName, sam){
    if (typeof sam === 'undefined') {
      sam = 'pb';
    }
    var name = '\'sam_' + sam + '_submission[' + fieldName + ']\'';

    $('[name=' + name + ']').removeAttr('required');
    $('[name=' + name + ']').val('');
    $('label[for=' + name + ']').removeClass('required');
  }

  function lengthValidation(field) {
    if (field.val() == '' || field.data('length-validation') === undefined) {
      return false;
    }
    if (field.val().length != field.data('length-validation')) {
      field.addClass('sam_field_with_errors');
      field.parent().append('<div class=\'sam-required-error\'>Should be ' + field.data('length-validation') + ' characters in length </div>');
      return true;
    }
    return false;
  }

  function maxLengthValidation(field) {
    if (field.val() == '' || field.data('max-length-validation') === undefined) {
      return false;
    }
    if (field.val().length > field.data('max-length-validation')) {
      field.addClass('sam_field_with_errors');
      field.parent().append('<div class=\'sam-required-error\'>' + field.val().length + ' characters entered. Can\'t be more than ' + field.data('max-length-validation') + '</div>');
      return true;
    }
    return false;
  }

  function checkRequiredRadioButtons(sam, fieldName, div) {
    var name = '\'sam_' + sam + '_submission[' + fieldName + ']\'',
      flag = false;
    if ($('[name=' + name + ']:checked').length == 0) {
      if($('.' + div).length) { $('.' + div).show(); }
      flag = true;
    } else {
      if($('.' + div).length) { $('.' + div).hide(); }
    }
    return flag;
  }

  return {
    showOnCheck:showOnCheck,
    hideOnCheck:hideOnCheck,
    requiredOnCheck:requiredOnCheck,
    notRequiredOnCheck:notRequiredOnCheck,
    makeRequiredByName:makeRequiredByName,
    removeRequiredByName:removeRequiredByName,
    requireRadioButtonSelection:requireRadioButtonSelection,
    checkRequiredRadioButtons:checkRequiredRadioButtons,
    lengthValidation:lengthValidation,
    maxLengthValidation:maxLengthValidation
  };
})($);